module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18324/js/img/valuePropModals/SequencesEmailCommunicator/ValueProp3.svg"